import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import confidencePNG from '~/assets/images/communication/confidence.png'
import confidenceWEBP from '~/assets/images/communication/confidence.webp'
import {
  CONFIDENCE_OPTIONS,
  CONFIDENCE_QUESTION,
} from '~/pages/communication/confidence/libs/components/ConfidenceCommunication/constants'
import { ConfidenceCommunicationStyles as S } from '~/pages/communication/confidence/libs/components/ConfidenceCommunication/styles'
import { parseEmojiOption } from '~/pages/communication/libs/parseEmojiOption'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const ConfidenceCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: CONFIDENCE_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationConfidence.title"
            />
          </S.Title>
        </S.TitleGroup>

        <S.ImageWrapper>
          <picture>
            <source srcSet={confidenceWEBP} type="image/webp" />
            <img
              src={confidencePNG}
              alt="How confident are you in conversations?"
            />
          </picture>
        </S.ImageWrapper>

        <S.Options>
          {CONFIDENCE_OPTIONS.map(({ key, i18nKey }) => {
            const { emoji, label } = parseEmojiOption(
              t(`onboarding.communicationConfidence.options.${i18nKey}`),
            )

            return (
              <S.OptionButton
                key={key}
                type="button"
                $isSelected={answer === key}
                disabled={isAnswersDisabled}
                onClick={() => {
                  if (isAnswersDisabled) return
                  setAnswer(key)
                  handleChange(key, handleContinue)
                  setIsAnswersDisabled(true)
                }}
              >
                <S.OptionEmoji>{emoji}</S.OptionEmoji>
                <S.OptionLabel>{label}</S.OptionLabel>
              </S.OptionButton>
            )
          })}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default ConfidenceCommunication
